import { Inject, Injectable } from '@angular/core';
import { BaseDTO } from '../../utils/BaseDTO';

import { EditForm } from '../models/EditForm';
import { UploadImageResponse } from '../../utils/models/UploadImageResponse';
import { Environment } from '@t-llevo/util';
import { DriverRequest } from '../../api/models/requests/DriverRequest';
import { VehicleRequest } from '../../api/models/requests/VehicleRequest';
import { UserRequest } from '../../api/models/requests/UserRequest';
import { LicenseRequest } from '../../api/models/requests/LicenseRequest';

type DtoParam = {
  data: EditForm;
  driverPhoto: UploadImageResponse;
  licensesPhoto: UploadImageResponse[];
};

type DtoResponse = Omit<DriverRequest, 'vehicle' | 'user'> & {
  vehicle: VehicleRequest;
  user: Omit<UserRequest, 'password'>;
};

@Injectable({
  providedIn: 'root',
})
export class EditDriverRequestDTO extends BaseDTO<DtoParam, DtoResponse> {
  constructor(@Inject(Environment) private env: Environment){
    super()
  }

  override mapTo(params: DtoParam): DtoResponse {
    const licences: LicenseRequest[] = []
    for(let i = 0; i < params.data.licenses.length; i++){
      const licenseImage = params.licensesPhoto[i].data.replace(
        'public/licences/',
        `${this.env.apiUrl}files/managefiles/licences/`
      );

      licences.push({
        categories: params.data.licenses[i].categories,
        licenseNumber: params.data.licenses[i].licenseNumber,
        expeditionDate: params.data.licenses[i].expeditionDate,
        expiredYear: params.data.licenses[i].expiredYear,
        image: licenseImage
      })
    }

    const driverImage = params.driverPhoto.data.replace(
      'public/drivers/',
      `${this.env.apiUrl}files/managefiles/drivers/`
    );

    return {
      licences,
      vehicle: params.data.vehicle,
      user: {
        firstname: params.data.personal.name,
        lastname: params.data.personal.lastname,
        phone: params.data.personal.phone,
        email: params.data.personal.email,
        roles: ['driver'],
      },
      ci: params.data.personal.dni,
      photo: driverImage,
      birthday: params.data.personal.birthday,
    };
  }
}
